import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import FormUserSettings from "./FormsSettiongs/FormUserOptions";
import PedidoOptions from "./FormsSettiongs/FormPedidosOptions";
import ProdutoOptions from "./FormsSettiongs/FormProdutosOptions";
import FormsIntegraOptions from "./FormsSettiongs/FormsIntegraOptions";
import {BackEndRoutes} from "../../config/back-end-routes";
import {FrontEndRoutes} from "../../config/front-end-routes";
import {Form} from "react-bootstrap";
import {toast} from "react-toastify";
import FormPrazosPagamento from "./FormsSettiongs/Prazos/FormPrazosPagamento";
import PageTabelaPrice from "../Produtos/PriceProdutos/PageTabelaPrice";

const PageConfiguracoes: React.FC = () => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState("utilizador");
    const [configData, setConfigData] = useState<any>(null);
    const [originalData, setOriginalData] = useState<any>(null); // Para comparação
    const [previewLogo, setPreviewLogo] = useState<string | null>(configData?.logo || null);

    const handleLogoUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            const reader = new FileReader();

            // Converte a imagem para uma URL para pré-visualização
            reader.onloadend = () => {
                setPreviewLogo(reader.result as string);
                if (setConfigData) {
                    setConfigData({ ...configData, path_logo_empresa: reader.result });
                }
            };
            reader.readAsDataURL(file);
        }
    };
    const removeMask = (value: string | undefined): string => {
        return value ? value.replace(/\D/g, '') : '';
    };


    const handleSave = () => {
        if (!configData || !originalData) return;

        const updatedFields = Object.keys(configData).reduce((acc, key) => {
            if (configData[key] !== originalData[key]) {
                acc[key] = configData[key];
            }
            return acc;
        }, {} as Record<string, any>);

        if (Object.keys(updatedFields).length > 0) {
            const dataToSend = {
                ...updatedFields,
                telefone: removeMask(configData.telefone),
                celular: removeMask(configData.celular),
                cep: removeMask(configData.cep),
            };

            // Validação
            const isValidPhoneNumber = (phone:any) => /^\d{10,11}$/.test(phone);
            const isValidCEP = (cep:any) => /^\d{8}$/.test(cep);

            if (
                !isValidPhoneNumber(dataToSend.telefone) ||
                !isValidPhoneNumber(dataToSend.celular) ||
                !isValidCEP(dataToSend.cep)
            ) {
                toast.error("Por favor, verifique os campos de telefone, celular e CEP.");
                return;
            }

            axios.put(BackEndRoutes.routes.CONFIG.UPDATE, dataToSend)
                .then(() => {
                    toast.success("Configurações salvas com sucesso!");
                    setOriginalData(configData);
                })
                .catch((error) => {
                    console.error("Erro ao salvar configurações:", error);
                    toast.error("Erro ao salvar configurações.");
                });
        } else {
            toast.error("Nenhuma alteração para salvar.");
        }
    };
    console.log(configData, 'data config aqui')

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        setConfigData({ ...configData, certificadoDigital: file });
    };
    useEffect(() => {
        const fetchConfig = () => {
            axios.get(BackEndRoutes.routes.CONFIG.SHOW)
                .then((response) => {
                    setConfigData(response.data);
                    setOriginalData(response.data);
                    setPreviewLogo(response.data?.path_logo_empresa); // Atualize a previewLogo
                })
                .catch((error) => {
                    console.error("Erro ao buscar configurações:", error);
                });
        };

        fetchConfig();
    }, []);

    if (!configData) {
        return <div className='d-flex justify-content-center align-items-center'>Carregando configurações...</div>;
    }

    return (
        <div className="d-flex flex-column container-fluid">
            <div className="card border-secondary ">
                <div className="card-header">
                    <ul className="nav nav-tabs card-header-tabs row" role="tablist">
                        <li className="nav-item col-6 col-lg-auto border-start border-bottom">
                            <button
                                className={`nav-link ${activeTab === "utilizador" ? "active text-black" : ""}`}
                                style={{ color: activeTab === "utilizador" ? "black" : "#3490dc" }}
                                onClick={() => setActiveTab("utilizador")}
                            >
                                Dados do Utilizador
                            </button>
                        </li>
                        <li className="nav-item col-6 col-lg-auto border-start border-bottom">
                            <button
                                className={`nav-link ${activeTab === "produtos" ? "active text-black" : ""}`}
                                style={{ color: activeTab === "produtos" ? "black" : "#3490dc" }}
                                onClick={() => setActiveTab("produtos")}
                            >
                                Opções de Produtos
                            </button>
                        </li>
                        <li className="nav-item col-6 col-lg-auto border-start border-bottom">
                            <button
                                className={`nav-link ${activeTab === "pedidos" ? "active text-black" : ""}`}
                                style={{ color: activeTab === "pedidos" ? "black" : "#3490dc" }}
                                onClick={() => setActiveTab("pedidos")}
                            >
                                Opções de Pedidos
                            </button>
                        </li>
                        <li className="nav-item col-6 col-lg-auto border-start border-bottom">
                            <button
                                className={`nav-link ${activeTab === "integracao" ? "active text-black" : ""}`}
                                style={{ color: activeTab === "integracao" ? "black" : "#3490dc" }}
                                onClick={() => setActiveTab("integracao")}
                            >
                                Opções de Integração
                            </button>
                        </li>
                        <li className="nav-item col-6 col-lg-auto border-start border-bottom">
                            <button
                                className={`nav-link ${activeTab === "prazos" ? "active text-black" : ""}`}
                                style={{ color: activeTab === "prazos" ? "black" : "#3490dc" }}
                                onClick={() => setActiveTab("prazos")}
                            >
                                Prazos de Pagamento
                            </button>
                        </li>
                        <li className="nav-item col-6 col-lg-auto border-start">
                            <button
                                className={`nav-link ${activeTab === "precos" ? "active text-black" : ""}`}
                                style={{ color: activeTab === "precos" ? "black" : "#3490dc" }}
                                onClick={() => setActiveTab("precos")}
                            >
                                Tabela de Preços
                            </button>
                        </li>
                        <li className="nav-item col-6 col-lg-auto border-start">
                            <button
                                className={`nav-link ${activeTab === "logotipo" ? "active text-black" : ""}`}
                                style={{ color: activeTab === "logotipo" ? "black" : "#3490dc" }}
                                onClick={() => setActiveTab("logotipo")}
                            >
                                Opções de Logotipo
                            </button>
                        </li>

                    </ul>
                </div>

                <div className="tab-content mt-3 border border-top-0 rounded-bottom">
                    {/* Dados do Utilizador */}
                    {activeTab === "utilizador" && (
                        <div className="card-body">
                            <div className='d-flex justify-content-between align-items-center'>
                                <div className='d-flex align-items-center justify-content-center'>
                                    <h5>Dados do Utilizador</h5>
                                </div>

                                < div className="col-md-6 col-lg-4">
                                    <label>Ultima atualização</label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        disabled
                                        value={configData?.ultima_atualizacao_dados}
                                        placeholder=""
                                    />
                                </div>
                            </div>
                            <FormUserSettings
                                configData={configData}
                                setConfigData={setConfigData}
                            />
                        </div>
                    )}

                    {/* Opções de Produtos */}
                    {activeTab === "produtos" && (
                        <div className="card-body">
                            <ProdutoOptions
                                configData={configData}
                                setConfigData={setConfigData}
                            />
                        </div>
                    )}

                    {/* Opções de Pedidos */}
                    {activeTab === "pedidos" && (
                        <div className="card-body">
                            <PedidoOptions
                                configData={configData}
                                setConfigData={setConfigData}
                            />
                        </div>
                    )}

                    {/* Opções de Integração */}
                    {activeTab === "integracao" && (
                        <div className="card-body">
                            <FormsIntegraOptions
                                configData={configData}
                                setConfigData={setConfigData}
                            />
                        </div>
                    )}
                    {activeTab === "prazos" && (
                        <div className="card-body">
                            <FormPrazosPagamento />
                        </div>
                    )}
                    {activeTab === "precos" && (
                        <div className="card-body">
                            <PageTabelaPrice />
                        </div>
                    )}

                    {activeTab === "logotipo" && (
                        <div className="card-body">
                            {/* Input para Upload de Logo */}
                            <Form.Group controlId="selecionar-logo" className="col-12 col-lg-6 mb-3">
                                <Form.Label>Selecione Logotipo</Form.Label>
                                <Form.Control
                                    type="file"
                                    accept="image/*"
                                    onChange={handleLogoUpload}
                                />
                            </Form.Group>

                            {/* Pré-visualização da Logo */}
                            <Form.Group>
                                <Form.Label>Pré-visualização da Logotipo</Form.Label>
                                <div className="border p-2 rounded bg-light text-center">
                                    {configData.path_logo_empresa || previewLogo ? (
                                        <img
                                            src={previewLogo || `${BackEndRoutes.routes.CONFIG}${configData.path_logo_empresa}`}
                                            alt="Logotipo do cliente"
                                            style={{ maxWidth: "100%", height: "auto" }}
                                        />
                                    ) : (
                                        <span>Nenhuma logotipo selecionada</span>
                                    )}
                                </div>
                            </Form.Group>
                        </div>
                    )}
                </div>

                <div className="card-footer d-flex justify-content-end">
                    <button className="btn "
                        style={{ background: "#3490dc", color: "white" }}
                        onClick={handleSave}>
                        Salvar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PageConfiguracoes;
